import { portalLogout } from './portalAuth';

const BASE = process.env.REACT_APP_API_URL || 'http://localhost:5134';

function handleUnauthorized() {
  portalLogout();
  window.location.replace('/portal/login');
}

async function req(method, path, body) {
  const res = await fetch(`${BASE}${path}`, {
    method,
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
  });
  if (res.status === 401) { handleUnauthorized(); throw new Error('Unauthorized'); }
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: res.statusText }));
    throw Object.assign(new Error(err.error || res.statusText), { status: res.status });
  }
  return res.status === 204 ? null : res.json();
}

async function getBlob(path) {
  const res = await fetch(`${BASE}${path}`, { credentials: 'include' });
  if (!res.ok) throw new Error('Download failed');
  return res.blob();
}

export const portalApi = {
  requestMagicLink: (email) => req('POST', '/portal/auth/request', { email }),
  verifyMagicLink:  (token) => req('GET',  `/portal/auth/verify/${token}`),
  logout:           ()      => req('POST', '/portal/auth/logout'),
  me:               ()      => req('GET',  '/portal/me'),
  contracts:        ()      => req('GET',  '/portal/contracts'),
  contract:         (id)    => req('GET',  `/portal/contracts/${id}`),
  contractPdf:      (id)    => getBlob(`/portal/contracts/${id}/pdf`),
  invoices:         ()      => req('GET',  '/portal/invoices'),
  invoice:          (id)    => req('GET',  `/portal/invoices/${id}`),
};
